function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4621 0.210693L14.3728 12.4716H17.7144L19.8054 0.210693H16.4621Z",
  fill: "#7F7F7F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5696 0.224014L8.29679 8.58562L7.94786 7.32309C7.30241 5.80186 5.47006 3.61713 3.31885 2.24029L6.31146 12.4652L9.84725 12.4592L15.1097 0.221436L11.5696 0.224014Z",
  fill: "#7F7F7F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67966 1.10188C6.48542 0.355015 5.92248 0.132417 5.22375 0.105774H0.0429726L0 0.349859C4.03169 1.32791 6.69943 3.68453 7.8064 6.51814L6.67966 1.10188Z",
  fill: "#7F7F7F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5757 2.56117C27.6689 2.54398 28.4613 2.7829 29.0767 3.03043L29.3784 3.17224L29.8305 0.514811C29.1687 0.266429 28.1313 0 26.837 0C23.535 0 21.2076 1.66304 21.1895 4.0463C21.168 5.80731 22.8474 6.79053 24.116 7.37753C25.418 7.97915 25.8546 8.36161 25.8486 8.89876C25.8383 9.71954 24.8104 10.096 23.8504 10.096C22.5122 10.096 21.8014 9.9112 20.7039 9.45397L20.2733 9.25801L19.8032 12.0022C20.5853 12.3452 22.0283 12.64 23.5264 12.6554C27.039 12.6554 29.3217 11.0122 29.3457 8.4656C29.3603 7.07243 28.4691 6.00929 26.5379 5.13694C25.369 4.56799 24.654 4.18983 24.6608 3.61571C24.6608 3.10606 25.2676 2.56117 26.5757 2.56117Z",
  fill: "#7F7F7F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4084 0.224731H35.8266C35.0247 0.224731 34.4282 0.443032 34.0759 1.24232L29.1143 12.4788H32.6234C32.6234 12.4788 33.1958 10.9679 33.3256 10.637C33.7097 10.637 37.1192 10.6421 37.6048 10.6421C37.7045 11.0702 38.0122 12.4788 38.0122 12.4788H41.1122L38.4084 0.224731ZM34.2873 8.12739C34.5623 7.4235 35.6186 4.70076 35.6186 4.70076C35.6005 4.73427 35.891 3.99171 36.0638 3.53018L36.289 4.58731C36.289 4.58731 36.9293 7.5146 37.0633 8.12739H34.2873Z",
  fill: "#7F7F7F"
});

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 13,
    viewBox: "0 0 42 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.e6255c5d.svg";
export { ForwardRef as ReactComponent };